var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { Accordion } from "../../../../components/Accordion/Accordion";
import { AccordionDetails } from "../../../../components/Accordion/AccordionDetails";
import { AccordionSummary } from "../../../../components/Accordion/AccordionSummary";
import { List } from "../../../../components/List/List";
import { ListItem } from "../../../../components/List/ListItem";
import { TriStateCheckbox } from "../../../../components/TriStateCheckbox/TriStateCheckbox";
import { Typography } from "../../../../components/Typography/Typography";
import { clickableStyle, makeStyles } from "../../../../styles/index";
import { borderStyle } from "../../../../utils/style-utils";
import { WorkTemplate } from "./WorkTemplate";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    summary: {
        height: 48,
        borderLeft: function (_a) {
            var subjectColor = _a.subjectColor;
            return borderStyle((subjectColor === null || subjectColor === void 0 ? void 0 : subjectColor.primary) || theme.palette.common.white, 4);
        },
        touchAction: 'manipulation',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        position: 'relative',
        backgroundColor: function (_a) {
            var subjectColor = _a.subjectColor;
            return subjectColor === null || subjectColor === void 0 ? void 0 : subjectColor.sedondary;
        },
    },
    leftItem: {
        display: 'flex',
        flex: '1 0 0%',
        alignItems: 'center',
    },
    title: {
        marginRight: '2em',
    },
    rightItem: {
        display: 'flex',
        paddingRight: theme.spacing(2),
    },
    clickable: __assign({}, clickableStyle(theme)),
    item: {
        borderTop: function (_a) {
            var subjectColor = _a.subjectColor;
            return borderStyle((subjectColor === null || subjectColor === void 0 ? void 0 : subjectColor.tertiary) || theme.palette.common.white, 1);
        },
        padding: 0,
        width: '100%',
    },
}); }, { name: 'SnWorkTemplateGroup' });
export var WorkTemplateGroup = function (_a) {
    var _b = _a.model, groupId = _b.id, name = _b.name, workTemplates = _b.workTemplates, subjectColor = _a.subjectColor, remainingCount = _a.remainingCount, onSelectWorkTemplate = _a.onSelectWorkTemplate, onUnselectWorkTemplate = _a.onUnselectWorkTemplate, onClickWorkTemplate = _a.onClickWorkTemplate;
    var classes = useStyles({ subjectColor: subjectColor });
    var templateIds = workTemplates.map(function (_a) {
        var id = _a.id;
        return id;
    });
    var selectedTemplateIds = workTemplates.filter(function (_a) {
        var selected = _a.selected;
        return selected;
    }).map(function (_a) {
        var id = _a.id;
        return id;
    });
    var unCheckedCount = templateIds.length - selectedTemplateIds.length;
    var groupCheckboxState = getGroupCheckboxState(templateIds, selectedTemplateIds);
    var disableGroupCheckbox = remainingCount < unCheckedCount && groupCheckboxState !== 'checked';
    var handleClickGroupCheckbox = function (event) {
        event.stopPropagation();
        // 全てのワークテンプレートが選択状態になっていた場合は全てのidを投げる
        // それ以外の場合は選択されていないワークテンプレートのidのみ投げる
        if (templateIds.length === selectedTemplateIds.length) {
            onUnselectWorkTemplate(templateIds);
        }
        else {
            onSelectWorkTemplate(templateIds.filter(function (id) { return !selectedTemplateIds.includes(id); }));
        }
    };
    var handleClickCheckbox = function (id) {
        selectedTemplateIds.includes(id) ? onUnselectWorkTemplate([id]) : onSelectWorkTemplate([id]);
    };
    return (React.createElement(Accordion, { className: classes.root, id: groupId + "." + name, style: { boxShadow: 'none' } },
        React.createElement(AccordionSummary, { className: classNames(classes.summary, classes.clickable) },
            React.createElement("div", { className: classes.leftItem },
                React.createElement(Typography, { className: classes.title, variant: "body1" }, name)),
            React.createElement("div", { className: classes.rightItem },
                React.createElement(TriStateCheckbox, { disabled: disableGroupCheckbox, style: { touchAction: 'auto' }, value: groupCheckboxState, onClick: handleClickGroupCheckbox }))),
        React.createElement(AccordionDetails, { style: { padding: 0 } },
            React.createElement(List, { disablePadding: true }, workTemplates.map(function (workTemplate) {
                return (React.createElement(ListItem, { key: workTemplate.id, className: classes.item, disableGutters: true },
                    React.createElement(WorkTemplate, { model: workTemplate, remainingCount: remainingCount, onClickCheckbox: function () { return handleClickCheckbox(workTemplate.id); }, onClickWorkTemplate: function () { return onClickWorkTemplate === null || onClickWorkTemplate === void 0 ? void 0 : onClickWorkTemplate(workTemplate.courseId, workTemplate.templateGroupId, workTemplate.id); } })));
            })))));
};
function getGroupCheckboxState(templateIds, selectedTemplateIds) {
    if (selectedTemplateIds.length === 0) {
        return 'unchecked';
    }
    return templateIds.length === selectedTemplateIds.length ? 'checked' : 'indeterminate';
}
